import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-the-category-list" }
const _hoisted_2 = { class: "p-the-category-list__item__trigger" }
const _hoisted_3 = { class: "p-the-category-list__item__trigger__label" }
const _hoisted_4 = { class: "p-the-category-list__item__target" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "p-the-category-list__item__target__item" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_IconArrowBottom = _resolveComponent("IconArrowBottom")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_DropdownMenuAnimation = _resolveComponent("DropdownMenuAnimation")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemCategories, (category, key) => {
      return (_openBlock(), _createElementBlock("li", {
        key: key,
        class: "p-the-category-list__item"
      }, [
        _createVNode(_component_DropdownMenuAnimation, null, {
          trigger: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              (category.icon)
                ? (_openBlock(), _createBlock(_component_InlineSvg, {
                    key: 0,
                    src: category.icon,
                    width: "30",
                    height: "30",
                    fill: _ctx.colorCode,
                    "aria-label": category.name
                  }, null, 8, ["src", "fill", "aria-label"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_3, _toDisplayString(category.name), 1)
            ])
          ]),
          arrow: _withCtx(() => [
            _createVNode(_component_IconBase, {
              "view-box": "0 0 24 24",
              width: "24",
              height: "24",
              color: "#b6b6b6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconArrowBottom)
              ]),
              _: 1
            })
          ]),
          target: _withCtx(() => [
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.sub_categories, (child, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  class: "p-the-category-list__item__target__item"
                }, [
                  _createElementVNode("a", {
                    class: "p-the-category-list__item__target__item__link",
                    onClick: ($event: any) => (_ctx.clickOnSubcategory(child.id))
                  }, _toDisplayString(child.name), 9, _hoisted_5)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("a", {
                  class: "p-the-category-list__item__target__item__link",
                  onClick: ($event: any) => (_ctx.clickOnSubcategory(category.id))
                }, "全て見る", 8, _hoisted_7)
              ])
            ])
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128))
  ]))
}